import { HelpOther } from '@/common/helper';
import ModelManagementPrivateConfirm from '@/components/modal/modal-management/confirm';
import homeStore from '@/pages/home/store';
import globalStore from '@/store/global';
import { SVGPureIcon } from '@/ui';
import { request } from '@src/common';
import { Tooltip } from 'antd';
import { Image } from 'antd/es';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import store from '../store';

const DotIcon = observer(({ item }) => {
  const [visible, setVisible] = useState(false);
  const handleEdit = () => {
    ModelManagementPrivateConfirm.show({isEdit: true, item});
    setVisible(false);
  };

  const handleDelete = () => {
    request.post('/user/firm/custom/del', {id: item.id}, {
      dataIsJson : true,
    }).then((res) => {
      if (res.code === 0) {
        store.delModelFirm(item.id);
        homeStore.setDirty();
        return
      }
      HelpOther.toast('删除失败', 'error');
    }).catch(err => {
      HelpOther.toast('删除失败', 'error');
    });
    setVisible(false);
  };

  const FloatMenu = () => {
    return <div className='w-150px py-6px text-[#000] '>
      <div className='h-40px flex items-center text-14px pl-8px hover:bg-hover-card leading-40px rounded-8px gap-6px cursor-pointer'
        onClick={(e) => {
          e.stopPropagation();
          handleEdit();
        }}
      >
        <SVGPureIcon className="size-20px" name="icon_edit"></SVGPureIcon>
        编辑
      </div>
      <div className='h-40px flex items-center text-14px pl-8px hover:bg-hover-card leading-40px rounded-8px gap-6px cursor-pointer'
       onClick={(e) => {
        e.stopPropagation();
        handleDelete();
      }}
      >
        <SVGPureIcon className="size-15px" name="icon_delete"></SVGPureIcon>
        删除
      </div>
    </div>
  }
  return (
    <div>
      <Tooltip open={visible} overlayClassName="custom-tooltip" placement="top" arrow={false} trigger="click" title={FloatMenu}>
        <div 
            className='hover:bg-[rgba(0,0,0,0.03)] h-28px w-28px flex items-center justify-center rounded-8px cursor-pointer'
            onClick={(e) => {
              e.stopPropagation();
              setVisible(!visible);
            }}
          >
            <SVGPureIcon className="size-14px opacity-70" name="more_icon"></SVGPureIcon>
        </div>
      </Tooltip>
    </div>
  )
})

const ListItem = observer(({ item }) => {
  const [isHovered, setIsHovered] = useState(false);
  const setActive = () => {
    const bg = globalStore.isDark ? 'bg-[#282832]' : 'bg-[#e8e8e8]'
     return (store.activeModel?.id === item?.id) ? bg : ''
  }
  const getIcon = () => {
    return item?.icon || item?.models?.[0]?.icon
  }

  const renderStatusElement = () => {
    // 是否显示操作点按钮
    const isShowDotIcon = (item?.model_type === 3 || item?.model_type === 4) &&
                          isHovered &&
                          !item?.is_preset && !store.isPreset(item.id);
    
    if (isShowDotIcon) {
      return <DotIcon item={item} />;
    }
    
    // 是否显示已启用标签
    if (item?.enable) {
      const tagClassName = [
        'h-16px leading-16px text-[#7B7E81] rounded-4px px-4px',
        globalStore.isDark ? 'bg-[rgba(255,255,255,0.06)]' : 'bg-[rgba(0,0,0,0.06)]'
      ].join(' ');
      
      return (
        <div className="text-12px flex items-center">
          <div className={tagClassName}>已启用</div>
        </div>
      );
    }
    
    // 默认返回null而不是空字符串
    return null;
  };

  return (
    <div
      key={item.id}
      className={[
        "flex justify-between items-center",
        "h-40px p-8px box-border",
        "rounded-12px cursor-pointer",
        "hover:bg-[#efefef]",
        setActive(),
      ]}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        store.setActiveModel(item);
      }}
    >
      <div className={`size-24px flex-shrink-0 overflow-hidden rounded-8px mr-14px relative`}>
        <Image
          preview={false}
          src={getIcon()}
          fallback={`https://p4.ssl.qhimg.com/t110b9a930179fa89dbae660a1a.png`}
          className={[
            `!w-24px !h-24px !object-cover ${item?.model_type !== 4 ? 'rounded-full' : 'rounded-8px bg-white'}`
          ]}
          rootClassName="!w-24px !h24px !object-cover rounded-8px"
        />
      </div>
      <div className="flex-grow w-0 flex flex-col justify-center">
        <div className="text-14px font-bold text-primary-opacity leading-22px truncate">
          {item?.name}
        </div>
      </div>
      {
        renderStatusElement()
      }
    </div>
  );
});

const List = observer(() => {
  return (
    <div className='w-200px h-73vh bg-gray-nav rounded-12px bg-[#f7f7f7]'>
      <div
        className='gap-4px h-[calc(100%-44px)] nw-scrollbar overflow-y-auto flex flex-col p-4px'
      >
        <InfiniteScroll
          dataLength={store.modeList?.length}
          loader={null}
        >
         {store.modeList?.map((item) => (
          <ListItem
            key={item.id}
            item={item}
          />
        ))}
        </InfiniteScroll>
      </div>
      {
        [30, 40].includes(store?.fromTab) && <div 
          className={[
            'h-40px rounded-12px cursor-pointer flex justify-center items-center ml-4px mr-4px',
            'text-14px border border-[rgba(0,0,0,0.1)] font-bold',
            globalStore.isDark ? 'bg-[#45454E]' : 'bg-[#ffffff]',
            globalStore.isDark ? 'hover:bg-[#55555D]' : 'hover:bg-[rgba(0,0,0,0.03)]',
          ]}
          onClick={() => {
            ModelManagementPrivateConfirm.show();
          }}
        >
          {
            store?.fromTab === 30 ? '添加私有模型' : '添加一体机'
          }
        </div>
      }
    </div>
  );
});
export default List;
